export default {
  text: 'Service Promotion',
  thumbnail:
    'https://vastreach.com/static_assets/email/thumnails/Service_promotion.jpg',
  snippets: {
    Button: {
      icon: 'RadioButton',
      text: 'Button',
      editor: 'button',
      html: '<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><p style="text-align: center;margin:0;"><a data-button-text="Start now" data-button-url="https://www.vastreach.com" data-button-color="#ffffff" data-button-background-color="#ffb83b" href="#" target="_blank"><button style="color: #ffffff; background-color: #ffb83b;border: 0; padding: 15px 25px; margin: 0; border-radius: 0.3rem; cursor: pointer;"><strong>Start Now</strong></button></a></p></div><!-- End of Dynamic WYSIWYG Content -->',
    },
    Social: {
      icon: 'Share',
      text: 'Social',
      editor: 'social-media',
      html: '<!-- Dynamic WYSIWYG Content --><table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center"><tr><td width="600" align="center"><table style="margin: 20px 0 20px 0;"><tr><td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #ffb83b; padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #ffb83b;padding: 4px; border-radius:28px;" /></a> </td><td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #ffb83b;padding: 4px; border-radius:28px;" /></a> </td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    Paragraph: {
      icon: 'Notes',
      text: 'Paragraph',
      editor: 'wysiwyg',
      html: `<!-- Dynamic WYSIWYG Content --><div style="max-width: 600px;margin: 0 auto 0;padding: 10px 20px;text-align: center;background: transparent;"> <span style="font-size: medium;color:#777777;padding: 0;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">We have over 40 Hot Tubs & Swim Spas on Display from Major Brands and Everything Must Go! </span></div><!-- End of Dynamic WYSIWYG Content -->`,
    },
    'Image + Paragraph': {
      icon: 'Image',
      text: 'Image + Paragraph',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"><tr><td> <table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 30px 20px 30px 20px;"><tr><td valign="top" width="33.33%"><table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;"><tr><td dir="ltr" valign="top" style="padding: 0 15px 15px 0"><img src="https://vastreach.com/static_assets/email/service_promotion/featured-1.png" alt="featured item 1" style="max-width: 100%;margin: 0 auto;display: block;"/></td></tr></table></td><td valign="top" width="66.66%"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td dir="ltr" valign="top" style="text-align: left;"><h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">Your Feature 1</span></h2><span style="font-size: medium;color: #777777;padding: 0 10px 0 10px;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your feature here. Explain it just enough for the viewer to get an idea of what it is, but not the whole picture so they may get curious and visit your link.</span></td></tr></table></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
    'Image Banner + Text': {
      icon: 'Satellite',
      text: 'Image Banner + Text',
      editor: 'wysiwyg',
      html: '<!-- Dynamic WYSIWYG Content --><table border="0" cellpadding="0" cellspacing="0" style="width: 100%; max-width: 600px; margin: 0 auto; padding: 0; text-align: center; background-color: #ffffff;"><tr><td valign="middle" style="background-image: url(https://vastreach.com/static_assets/snippets/customer_support.jpg);background-position: center center !important;background-size: cover !important;text-align: center;background-repeat: no-repeat;padding: 50px 0 50px 0;background-position: center;background-size: cover;"><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;"><tr><td valign="middle" style="text-align: center; padding: 50px 50px 50px; font-size: 15px; line-height: 20px; color: #ffffff;"><h2 style="font-size: 35px; font-weight: 600; font-family: Tahoma, Geneva, sans-serif; word-wrap: break-word; line-height: 1.5; display: inline-block; vertical-align: middle;">YOUR STATEMENT <b style="color: #ffb83b;">HERE</b></h2><p style="margin: 0; color: #ffffff; font-size: 14px; font-weight: 550; font-family: Arial, Helvetica, sans-serif;">Place a description or your mission statement here. We recommend using a darker image on lighter text or lighter image on darker text.</p></td></tr></table></td></tr></table><!-- End of Dynamic WYSIWYG Content -->',
    },
  },
  value: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" style="width: 100%;height: 100%;margin: 0;padding: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">

<head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="viewport" content="width=device-width"/>
	<meta class="vastreach-theme" data-vast-theme="servicePromotion"/>
</head>	

<body align="center" style="margin: 0;padding: 0;background-color: #ffffff;">
  <div class="background" style="background: #ffffff;">
    <div class="foreground" style="max-width: 600px;background: #ffffff;">
		<table style="max-width: 600px;margin: 0 auto 40px auto;padding: 0;text-align: center;border-radius: 2rem;border-spacing: 0;">	
			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<table style="width: 100%;max-width: 600px;margin: 0 auto 0;padding: 0;text-align: center;background: transparent;">
						<tr>
							<td valign="middle" style="background-image: url(https://vastreach.com/static_assets/email/service_promotion/banner.jpg);background-position: center center !important;background-size: cover !important;text-align: center;">
								<!-- Dynamic WYSIWYG Content -->
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 0 10px 0 10px;border-spacing: 0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
									<tr>
										<td class="col" width="290" valign="center" align="left">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td>
														<img src="https://vastreach.com/static_assets/email/service_promotion/beta-logo.png" alt="logo" style="max-width: 300px;margin-top: 20px;margin-bottom: 20px;" />
													</td>
												</tr>
											</table>
										</td>
										<td class="col" width="290" valign="center" align="right">
											<table cellpadding="0" cellspacing="0" style="border-spacing: 0;">
												<tr>
													<td>
														<a href="#" target="_blank" style="text-decoration: none;"><h2 style="margin-right: 10px;color: #ffffff;"><span style="font-size: medium;font-family: Arial, Helvetica, sans-serif;">Open in browser</span></h2></a>
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin: 0 auto 0 auto;border-spacing: 0;">
									<tr>
										<td valign="middle" style="text-align: center; padding: 50px 50px 50px 50px; font-size: 15px; line-height: 20px; color: #ffffff;">
											<h2><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">YOUR CATCH <b style="color: #ffb83b;">PHRASE</b></span></h2>
											<p><strong><span style="font-size: medium;color:#ffffff;padding: 0 10px 0 10px;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Place a description or your mission statement here.</span></strong></p>
											<!--<p><a href="#" target="_blank"><button style="color: #ffffff;background-color: #ffb83b;border: 0;padding: 15px 25px; border-radius: 2rem; cursor: pointer;"><b>Start Now</b></button></a></p>-->                           
										</td>
									</tr>	                                   	
								</table>
								<!-- End of Dynamic WYSIWYG Content -->
							</td>
						</tr>   
					</table>
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 5px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;"> 			
						<h1><span style="font-size: xx-large;font-family: Arial, Helvetica, sans-serif;">What can we do for you?</span></h1>
					</div> 
					<!-- End of Dynamic WYSIWYG Content -->							
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 5px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			
						<h3 style="color: #ffb83b;"><span style="font-size: medium;font-family: Arial, Helvetica, sans-serif;">OUR SERVICES</span></h3>	
					</div> 	
					<!-- End of Dynamic WYSIWYG Content -->						
				</td>	
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" align="center">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			
						<hr />
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" dir="ltr" valign="top" width="100%" style="margin: 0;padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td> 				
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 30px 20px 30px 20px;">
									<tr>
										<td valign="top" width="33.33%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="padding: 0 15px 15px 0">
														<img src="https://vastreach.com/static_assets/email/service_promotion/featured-1.png" alt="featured item 1" style="max-width: 100%;margin: 0 auto;display: block;"/>
													</td>
												</tr>
											</table>
										</td>
										<td valign="top" width="66.66%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%">
												<tr>
													<td dir="ltr" valign="top" style="text-align: left;">
														<h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">Your Feature 1</span></h2>
														<span style="font-size: medium;color: #777777;padding: 0 10px 0 10px;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your feature here. Explain it just enough for the viewer to get an idea of what it is, but not the whole picture so they may get curious and visit your link.</span>
														<!--<table cellspacing="0" cellpadding="0" border="0" style="float:left;border-spacing: 0;">
															<tr>
																<td style="display:block;margin: 20px 0 0 0;">
																	<p style="margin: 0;"><a href="#" target="_blank"><button style="padding: 7.5px 15px; background-color: transparent; border: 2px solid #ffb83b; color: #000000;border-radius: 2rem; cursor: pointer;">Learn More</button></a></p>							
																</td>
															</tr>
														</table>-->
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" dir="rtl" valign="top" width="100%" style="margin: 0;padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="width: 100%;max-width: 600px;margin: 0 auto;padding: 0;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">
						<tr>
							<td> 				
								<table border="0" cellpadding="0" cellspacing="0" width="100%" style="padding: 0 20px 30px 20px;border-spacing: 0;">
									<tr>
										<td valign="top" width="33.33%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-spacing: 0;">
												<tr>
													<td dir="ltr" valign="top" style="padding: 0 0 15px 15px;">
														<img src="https://vastreach.com/static_assets/email/service_promotion/featured-2.png" alt="featured item 2" style="max-width: 100%;margin: 0 auto;display: block;"/>
													</td>
												</tr>
											</table>
										</td>
										<td valign="top" width="66.66%">
											<table border="0" cellpadding="0" cellspacing="0" width="100%">
												<tr>
													<td dir="ltr" valign="top" style="text-align: left;">
														<h2><span style="font-size: x-large;font-family: Arial, Helvetica, sans-serif;">Your Feature 2</span></h2>
														<span style="font-size: medium;color: #777777;padding: 0 10px 0 10px;margin:0;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">Describe your feature here. Explain it just enough for the viewer to get an idea of what it is, but not the whole picture so they may get curious and visit your link.</span>
														<!--<table cellspacing="0" cellpadding="0" border="0" style="float:left;border-spacing: 0;">
															<tr>
																<td style="display:block;margin: 20px 0 0 0;">
																	<p style="margin: 0;"><a href="#" target="_blank"><button style="padding: 7.5px 15px; background-color: transparent; border: 2px solid #ffb83b; color: #000000;border-radius: 2rem; cursor: pointer;">Learn More</button></a></p>
																</td>
															</tr>
														</table>-->
													</td>
												</tr>
											</table>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</table>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="paragraph" align="center">
					<!-- Dynamic WYSIWYG Content -->
					<div style="max-width: 600px;margin: 0 auto;padding: 10px 20px;text-align: center;background: transparent;line-height: 1.65;font-size: 100%;font-family: Arial, Helvetica, sans-serif;">			
						<hr />
					</div>							
					<!-- End of Dynamic WYSIWYG Content -->
				</td>
			</tr>

			<tr>
				<td class="vastreach-sections" data-vast-editor="social-media" style="margin: 0;padding: 0;">
					<!-- Dynamic WYSIWYG Content -->
					<table style="margin: 0 auto;background: transparent;" border="0" cellpadding="0" cellspacing="0" align="center">
						<tr>
							<td width="600" align="center">
								<table style="margin: 20px 0 20px 0;">
									<tr>
										<td align="center"> <a data-social-media="facebook" href="https://www.facebook.com/" target="_blank"><img src="https://vastreach.com/static_assets/facebook.png" border="0" style="background-color: #ffb83b; padding: 4px; border-radius:28px;" /></a> </td>
										<td align="center"> <a data-social-media="instagram" href="https://www.instagram.com/" target="_blank"><img src="https://vastreach.com/static_assets/instagram.png" border="0" style="background-color: #ffb83b;padding: 4px; border-radius:28px;" /></a> </td>
										<td align="center"> <a data-social-media="twitter" href="https://twitter.com/" target="_blank"><img src="https://vastreach.com/static_assets/twitter.png" border="0" style="background-color: #ffb83b;padding: 4px; border-radius:28px;" /></a> </td>
									</tr>
								</table>
							</td>
						</tr>
					</table>
					<!-- End of Dynamic WYSIWYG Content -->			
				</td>	
			</tr>
		</table> 	
	</div>				
</div>				
</body>	
</html>`,
}
